import { selectAnamnesisHistory } from '../../store/slices/sickLeaveAndPrescription';
import { useAppSelector } from '../../store/store';
import CustomPagination from '../../components/UI/CustomPagination/CustomPagination';
import moment from 'moment';
import styles from './AnamnesisHistory.module.scss';
import { useTranslation } from '../../hooks/useTranslations';


interface AnamnesisHistoryProps {
  setSelectedAnamnesis: (id: number, itemId: number, datetime_create: string) => void;
}

export default function AnamnesisHistory({ setSelectedAnamnesis }: AnamnesisHistoryProps) {
  const anamnesisHistoryData = useAppSelector(selectAnamnesisHistory);
  const { translations } = useTranslation();

  const sortedData = anamnesisHistoryData
    .flatMap((group) =>
      group.anamnesis_questions
        .filter((q: any) => !isNaN(Date.parse(q.datetime_create)))
        .map((q: any) => ({
          ...q,
          groupName: group.anamnesis_question_group_name,
          groupId: group.anamnesis_question_group_id,
        }))
    )
    .sort(
      (a, b) =>
        new Date(b.datetime_create).setMilliseconds(0) -
        new Date(a.datetime_create).setMilliseconds(0)
    );

  const uniqueItemsByDate = Array.from(
    sortedData
      .reduce((map, item) => {
        if (!map.has(item.datetime_create)) {
          map.set(item.datetime_create, item);
        }
        return map;
      }, new Map())
      .values()
  );
  return (
    <div className={styles.anamnesisHistory}>
      <div className={styles.header}>
        <p className={styles.title}>{translations("anamnesis.history")}</p>
      </div>
      {uniqueItemsByDate?.length > 0 ? (
        <CustomPagination itemsPerPage={5} items={uniqueItemsByDate}>
          {(paginatedItems: any[]) => (
            <div className={styles.historyList}>
              {paginatedItems?.map((entry: any, idx: number) => {
                return (
                  <div
                    key={idx}
                    className={styles.historyItem}
                    onClick={() =>
                      setSelectedAnamnesis(
                        entry.groupId,
                        entry.product_order_item_id,
                        entry.datetime_create
                      )
                    }
                  >
                    <div className={styles.historyLeft}>
                      <p className="bold">
                        {moment(entry.datetime_create ?? '').format('DD MMMM YYYY')}
                      </p>
                    </div>
                    <div className={styles.historyRight}>
                      <i className="black-arrow-right" style={{ width: '8px', height: '14px' }}></i>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </CustomPagination>
      ) : (
        <p className={styles.noDataMessage}>{translations("anamnesis.history_missing")}</p>
      )}
    </div>
  );
}
